import {
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR,
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_START,
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';
import getMicroLoanNotifications from './getMicroLoanNotifications';

export default queries => dispatch =>
  dispatch(
    apiAction({
      url: `/user/notifications/micro-loan-requests`,
      method: 'PUT',
      API_REQUEST_START: READ_ALL_MICRO_LOAN_NOTIFICATIONS_START,
      API_REQUEST_SUCCESS: READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS,
      API_REQUEST_FAILURE: READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR,
      callbackOnSuccess: () =>
        getMicroLoanNotifications(queries)(dispatch),
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
